import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';

class CategoryService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiCategoryURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  listTemplateCategories = ({ role }) => {
    const request = {
      method: 'GET',
      url: '/categories/list',
      params: {
        role,
      },
    };
    return this.axios(request);
  };

  getChildCategory(parentId) {
    const request = {
      method: 'GET',
      url: `/children-categories`,
      params: {
        parent_category_id: parentId,
      },
    };
    return this.axios(request);
  }
}

export default new CategoryService();
